/**
 * 단독 glyph(Spinner·ProgressRing류)의 크기 축. 아이콘 램프를 타입 스케일 토큰에 물려 em-model로
 * 그리므로 typography scale 변경을 함께 따른다. RFC-inline-element-size-scale의 outer-height
 * scale(`inlineElementHeight`)과는 별개 축이다.
 */
export type GlyphSize = "sm" | "md" | "lg" | "xl";

export type GlyphSizeToken = "body" | "title" | "head" | "headLarge";

export const glyphSizeToken: Record<GlyphSize, GlyphSizeToken> = {
  sm: "body",
  md: "title",
  lg: "head",
  xl: "headLarge",
};
